export default __webpack_public_path__ + "static/media/blush.225c4c3f.jpg";